import { ReactNode, useState, useEffect } from 'react';
import LayoutWithSidebar from '@quicktools/shared-components/components/layout/LayoutWithSidebar';
import NextHead from '@quicktools/shared-components/components/common/NextHead';
import IconMenu from '@picsart/icons/IconMenu';
import { useTranslation } from 'react-i18next';

import { initializeLocalStorage } from '../../utils/common/localStorage';
import EditorSidebar from '../EditorPage/EditorSidebar';
import Header from '../EditorPage/Header';
import MobileNavigation from '../EditorPage/MobileNavigation';
import { MAIN_CONTENT_ID } from '../../constants';

import useStyles from './styles';

type LayoutProps = {
  children: ReactNode;
  category: number;
  metaTitleKey: string;
  metaDescriptionKey: string;
  canonicalPath: string;
  hasRawTitle?: boolean;
};

function Layout({
  children,
  metaTitleKey,
  metaDescriptionKey,
  canonicalPath,
  hasRawTitle,
  category,
}: LayoutProps) {
  const { t } = useTranslation();
  const classes = useStyles();
  const [showMenu, setShowMenu] = useState(false);
  const handleToggleMenu = () => {
    setShowMenu((prev) => !prev);
  };

  useEffect(() => {
    initializeLocalStorage();
  }, []);

  return (
    <>
      <NextHead
        title={t(metaTitleKey)}
        description={t(metaDescriptionKey)}
        canonicalPath={canonicalPath}
        noIndex
        hasRawTitle={hasRawTitle}
      ></NextHead>

      <LayoutWithSidebar
        mainClassName={classes.main}
        leftSidebarClassName={classes.sidebar}
        headerClassName={classes.header}
        header={
          <>
            <MobileNavigation
              selectedCategory={category}
              handleToggleMenu={handleToggleMenu}
              isVisible={showMenu}
            />
            <Header icon={IconMenu} handleToggleMenu={handleToggleMenu} category={category} />
          </>
        }
        main={
          <div className={classes.content} id={MAIN_CONTENT_ID}>
            {children}
          </div>
        }
        leftSidebar={<EditorSidebar />}
      />
    </>
  );
}

export default Layout;
